import { render } from "./Header.vue?vue&type=template&id=3a91b0f9"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=3a91b0f9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__